var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14v28a3.5 3.5 0 0 0 3.5 3.5h35a1.75 1.75 0 0 0 1.75-1.75v-24.5a1.75 1.75 0 0 0-1.75-1.75h-35a3.5 3.5 0 0 1-3.5-3.5Zm0 0a3.5 3.5 0 0 1 3.5-3.5H42.5",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 34.125a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z",
    fill: "currentColor"
  })));
};
export default SvgWallet;